module.exports = __webpack_public_path__ + "16-o1.jpg?8ec664da53d07436a9fbd038d13ba222";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/16-o1.jpg
// module id = 630
// module chunks = 0